export class ClientsSpecifications  {
  especificaciones:any[];

  constructor(especificaciones){
    this.especificaciones = [];

    // for(let i = 0;i < especificaciones.length;i++){
    //   if(especificaciones[i].value.check === true){
    //     this.especificaciones.push({'id':especificaciones[i].value.id});
    //   }
    // }
  }


  public getJson(){
    let coma =',';
    let esp = '';
    for(let i=0;i < this.especificaciones.length;i++){
      if((i+1) === this.especificaciones.length){
        coma = '';
      }
      esp += `{"type":"company_specification","specification_id":${this.especificaciones[i].id}}${coma}`;
    }

    return `{"data":[${esp}]}`;

  }

  public getJson2(data:any){
    let coma =',';
    let esp = '';
    for(let i=0;i < data.length;i++){
      if((i+1) === data.length){
        coma = '';
      }
      esp += `{"type":"company_specification","specification_id":${data[i].id}}${coma}`;
    }

    return `{"data":[${esp}]}`;

  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/model/ClientsSpecifications.ts